exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gift_card_assign_task[data-v-8840e0fc]{padding:0}.cover-image[data-v-8840e0fc]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-webkit-box-align:center;width:500px;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.cover-image .gift-card-image[data-v-8840e0fc]{border:1px dashed #d9d9d9;border-radius:6px;text-align:center;width:110px;height:165px}.cover-image .gift-card-image-selected[data-v-8840e0fc]{border:1px solid #409eff}", ""]);

// exports
